import React, { useState, useEffect, useRef, useCallback } from "react";
import Dropdown from "../../../Components/CustomDropdown/customdropdown";
import { useDispatch, useSelector } from "react-redux";
import ConfirmContinueButton from "../../../Components/ContinueButton/continue-button";
import ConfirmResetButton from "../../../Components/ContinueButton/reset-button";
import AddressAutocomplete from "../../../Components/addressInput/address-input";
import { updateFormData } from "../../../Redux/store/onboardingFormSlice";
import { useNavigate, useLocation } from "react-router-dom";
import { useToast } from "../../../Utils/toastContext";
import { debounce } from "lodash";
import CustomDropdownWithFetch from "../../../Components/CustomDropdown/custom-dropdown-fetchAPI";
import DocumentPreview from "../../Create-Investment/documentpreview";
import {
  setStepStatus,
  setRejectedFields,
} from "../../../Redux/store/onboardingFormSlice";
import LabelWithStatus from "../../../Components/onboarding/label-with-status";
import ReviewPopup from "../../../Components/onboarding/review-popup";
import { clearFileIdsRedux } from "../../../Redux/store/userSlice";
const BusinessInfo = ({ setCurrentStep }) => {
  const userStatus = useSelector((state) => state.user.userStatus);
  const stepStatus = useSelector((state) => state.form.stepStatus);
  const rejectedFields = useSelector((state) => state.form.rejectedFields);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [loading, setLoading] = useState(false);
  const updateFieldStatus = useSelector(
    (state) => state.user.updateFieldStatus,
  );
  const [citizenType, setcitizenType] = useState({
    verification_id: null,
    value: {
      id: 1,
      name: "Australian",
    },
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [businessName, setBusinessName] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [abn, setAbn] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [businessAddress, setBusinessAddress] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [redCity, setRedCity] = useState(null);
  const [redState, setRedState] = useState(null);
  const [currentField, setCurrentField] = useState({});
  const [currentFieldName, setCurrentFieldName] = useState("");
  const [currentFieldValue, setCurrentFieldValue] = useState("");
  const [currentFieldType, setCurrentFieldType] = useState("");
  const [nonResCountryText, setNonResCountryText] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [businessNature, setBusinessNature] = useState({
    verification_id: null,
    value: {
      id: null,
      name: "",
    },
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [taxId, setTaxId] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const fieldLabelMap = {
    tax_resident_country: "Tax Resident Country",
    country_id: "Country",
    business_nature: "Business Nature",
    business_registration_number: "Business Registration Number",
    tax_id: "Tax ID",
    abn: "ABN",
    business_name: "Business Name",
    business_activity: "Describe the business activity",
    other_business_activity: "Please mention business activity",
    source_of_funds: "Source of the funds including its origin",
    purpose_of_opening_account: "Purpose of opening caprock account",
    documents: "Supporting document",
    address_id: "Address of Principal Place of Business",
    nature_n_level_of_intended_transactions:
      "Nature and level of the intended transaction behaviour",
    beneficial_ownership_with_caprock:
      "Beneficial ownership of the funds used by this account with Caprock",
  };
  const [activity, setActivity] = useState({
    verification_id: null,
    value: {
      id: null,
      name: "",
    },
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [otherActivity, setOtherActivity] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [source, setSource] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [transactionLevel, setTransactionLevel] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [ownership, setOwnership] = useState({
    verification_id: null,
    value: true,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [businessRegNumber, setBusinessRegNumber] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [socialSecurityNumber, setSocialSecurityNumber] = useState("");
  const [apIAddress, setApIAddress] = useState("");
  const [isConfirmReset, setIsConfirmReset] = useState(false);
  const { showToast } = useToast();
  const [accountPurpose, setAccountPurpose] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });

  const [redCountry, setRedCountry] = useState(null);
  const [cityData, setCityData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [countryCodeData, setCountryCodeData] = useState([]);
  const [businessActivityData, setBusinessActivityData] = useState([]);
  const [businessNatureData, setBusinessNatureData] = useState([]);
  const [fileAttorneyPath, setfileAttorneyPath] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileAttorney, setFileAttorney] = useState(null);
  const [fileAvailable, setFileAvailable] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentDocument, setcurrentDocument] = useState({});
  const [preselectedCountryCode, setpreselectedCountryCode] = useState({});
  const [preselectedCitizenType, setpreselectedCitizenType] = useState({
    value: 1,
    label: "Australian",
  });
  const [preselectedBusinessNature, setpreselectedBusinessNature] = useState(
    {},
  );
  const [preselectedBusinessActivity, setpreselectedBusinessActivity] =
    useState({});

  const [countryCode, setCountryCode] = useState({
    verification_id: null,
    value: {
      id: 14,
      name: "Australia",
    },
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [citizenTypedata, setCitizenTypedata] = useState([]);

  const handleDeleteFile = () => {
    setFileAttorney(null);
    setFileAvailable(false);
    setfileAttorneyPath({
      verification_id: null,
      value: "",
      status: "pending",
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
  };
  const handleFileClick = (e, rowData) => {
    setcurrentDocument(rowData);
    setIsModalOpen(true);
  };
  const fileUploadNew = async (file) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {};

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/onboarding/upload/file`;
    const formData3 = new FormData();
    formData3.append("file", file); // Append file
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: formData3,
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later",
      );
    }
  };
  const handleFileChangeAttorney = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileAttorney(selectedFile);
        setLoading(true);
        handleUploadFileAttorney(selectedFile);
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error",
        );
      }
    }
    e.target.value = "";
  };
  const handleUploadFileAttorney = useCallback(
    debounce(async (fileUploaded) => {
      let toastMessage = null;
      try {
        const response = await fileUploadNew(fileUploaded);
        if (response.status == 201) {
          setfileAttorneyPath({
            ...fileAttorneyPath,
            value: response.data,
          });
          setFileAvailable(true);
        } else {
          setFileAvailable(false);
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        setFileAvailable(false);
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [fileAttorney], // Dependencies
  );
  const getLocation = async (country, state, city) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/v1/onboarding/location/ids`;

    let bodyData = {
      country: country,
      state: state,
      city: city,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const getAllLocationDetails = async () => {
    try {
      const response = await getLocation(
        businessAddress.value.country &&
          businessAddress.value.country.name &&
          businessAddress.value.country.name !== ""
          ? businessAddress.value.country.name
          : businessAddress.value.country,
        businessAddress.value.state &&
          businessAddress.value.state.name &&
          businessAddress.value.state.name !== ""
          ? businessAddress.value.state.name
          : businessAddress.value.state,
        businessAddress.value.city &&
          businessAddress.value.city.name &&
          businessAddress.value.city.name !== ""
          ? businessAddress.value.city.name
          : businessAddress.value.city,
      );
      setRedCountry(response.country_id);
      setRedState(response.state_id);
      setRedCity(response.city_id);
    } catch (err) {
      setRedCountry(null);
      setRedState(null);
      setRedCity(null);
      showToast(err.message, "error");
    } finally {
    }
  };
  useEffect(() => {
    if (
      (businessAddress.value && businessAddress.value.country) ||
      (businessAddress.value && businessAddress.value.country.name)
    ) {
      getAllLocationDetails();
    }
  }, [businessAddress]);
  const getAllCountries = async () => {
    try {
      const response = await GetAPIcalls(`/v1/user/countries?size=250`);

      if (response.status == 200) {
        let AllAccount = [];
        response.data.countries.forEach((profile) => {
          AllAccount.push({
            value: profile.id,
            label: profile.name,
          });
        });

        setCountryCodeData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getAllEnums = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/onboarding/business-information/enums`,
      );

      if (response.status == 200) {
        let AllAccount = [];
        response.data.business_activities.forEach((profile, index) => {
          AllAccount.push({
            value: profile.id,
            label: profile.name,
          });
        });

        setBusinessActivityData(AllAccount);
        let AllAccount2 = [];
        response.data.business_natures.forEach((profile, index) => {
          AllAccount2.push({
            value: profile.id,
            label: profile.name,
          });
        });
        setBusinessNatureData(AllAccount2);

        let AllAccount3 = [];
        response.data.tax_resident_countries.forEach((profile, index) => {
          AllAccount3.push({
            value: profile.id,
            label: profile.name,
          });
        });

        setCitizenTypedata(AllAccount3);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const handleContinue = (isFinal) => {
    if (!citizenType.value.name) {
      showToast("Please select tax resident country", "error");
      return;
    }
    if (!businessAddress.value || !redCountry) {
      showToast("Please enter valid business address", "error");
      return;
    }
    if (!businessName) {
      showToast("Please enter valid business name", "error");
      return;
    }
    if (citizenType.value.id == 1 && !abn.value) {
      showToast("Please enter ABN", "error");
      return;
    }
    if (!activity.value.id) {
      showToast("Please select business activity", "error");
      return;
    }
    if (activity.value.id == 6 && !otherActivity.value) {
      showToast("Please enter other activity", "error");
      return;
    }
    if (!accountPurpose) {
      showToast("Please enter the purpose of opening caprock account", "error");
      return;
    }
    if (citizenType.value.id == 2 && !countryCode.value.id) {
      showToast("Please select country", "error");
      return;
    }
    if (!businessNature.value.id) {
      showToast("Please select business nature", "error");
      return;
    }
    if (!source) {
      showToast("Please enter source of the funds", "error");
      return;
    }
    if (citizenType.value.id != 1 && !businessRegNumber.value) {
      showToast("Please enter business registration number", "error");
      return;
    }
    if (!transactionLevel.value) {
      showToast(
        "Please enter Nature and level of the intended transaction behaviour",
        "error",
      );
      return;
    }
    if (citizenType.value.id == 3 && !taxId.value) {
      showToast("Please enter Tax ID", "error");
      return;
    }
    setLoading(true);
    handlesave(isFinal);
  };
  const handleSelectCitizenType = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setcitizenType({
      ...citizenType,
      value: {
        id: selectedOption.value,
        name: selectedOption.label,
      },
    });
  };
  const handleStatusClick = (docData, fieldText, fieldValue, fieldType) => {
    setCurrentField(docData);
    setCurrentFieldName(fieldText);
    setCurrentFieldValue(fieldValue);
    setCurrentFieldType(fieldType);
    dispatch(clearFileIdsRedux());
    setShowPopup(true);
  };
  const handleSelectBusinessNature = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setBusinessNature({
      ...businessNature,
      value: {
        id: selectedOption.value,
        name: selectedOption.label,
      },
    });
  };

  const handleSelectActivity = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setActivity({
      ...activity,
      value: {
        id: selectedOption.value,
        name: selectedOption.label,
      },
    });
    setOtherActivity({
      verification_id: null,
      value: "",
      status: "pending",
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
  };
  const resetApplicationAPI = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/v1/onboarding/business-information/individual/reset`;
    let bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleReset = async () => {
    let toastMessage = null;
    try {
      const response = await resetApplicationAPI();
      if (response.status == 200) {
        toastMessage = {
          message: response.message,
          type: "success",
        };
        getDetailsWithVerification();
        const responseStatus = await GetAPIcalls(`/v1/onboarding/status`);
        if (responseStatus.status == 200) {
          if (responseStatus.data.length > 0) {
            dispatch(setStepStatus(responseStatus.data));
          }
        }
        const responseRejected = await GetAPIcalls(
          `/v1/onboarding/rejected-fields`,
        );
        if (responseRejected.status == 200) {
          dispatch(setRejectedFields(responseRejected.data)); // <-- Save in Redux
        }
      } else {
        toastMessage = { message: response.message, type: "error" };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: "error" };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const handleBack = () => {
    setCurrentStep(1);
  };
  const submitApplicationAPI = async (isFinal, payloadAddress) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let isOnbaording = userStatus == "onboarding" ? true : false;

    let apiUrl = isOnbaording
      ? `${BASE_URL}/v1/onboarding/business-information/individual/submit`
      : `${BASE_URL}/v1/onboarding/business-information/individual/update`;

    let bodyData = {};
    if (citizenType.value.id == 1) {
      bodyData = {
        tax_resident_country: citizenType.value.id,
        business_name: businessName.value,
        abn: abn.value,
        address: payloadAddress,
        business_activity: activity.value.id,
        other_business_activity: otherActivity.value,
        purpose_of_opening_account: accountPurpose.value,
        country_id: countryCode.value.id,
        business_nature: businessNature.value.id,
        source_of_funds: source.value,
        business_registration_number: businessRegNumber.value,
        nature_n_level_of_intended_transactions: transactionLevel.value,
        beneficial_ownership_with_caprock: ownership.value,
        documents: [
          {
            file_id: fileAttorneyPath.value.file_id,
            file_name: fileAttorneyPath.value.file_name,
          },
        ],
        is_submitted: isFinal,
      };
    }
    if (citizenType.value.id == 2) {
      bodyData = {
        tax_resident_country: citizenType.value.id,
        business_name: businessName.value,
        address: payloadAddress,
        business_activity: activity.value.id,
        other_business_activity: otherActivity.value,
        purpose_of_opening_account: accountPurpose.value,
        country_id: countryCode.value.id,
        business_nature: businessNature.value.id,
        source_of_funds: source.value,
        business_registration_number: businessRegNumber.value,
        nature_n_level_of_intended_transactions: transactionLevel.value,
        beneficial_ownership_with_caprock: ownership.value,
        documents: [
          {
            file_id: fileAttorneyPath.value.file_id,
            file_name: fileAttorneyPath.value.file_name,
          },
        ],
        is_submitted: isFinal,
      };
    }
    if (citizenType.value.id == 3) {
      bodyData = {
        tax_resident_country: citizenType.value.id,
        business_name: businessName.value,
        address: payloadAddress,
        business_activity: activity.value.id,
        other_business_activity: otherActivity.value,
        purpose_of_opening_account: accountPurpose.value,
        country_id: 233,
        business_nature: businessNature.value.id,
        source_of_funds: source.value,
        business_registration_number: businessRegNumber.value,
        nature_n_level_of_intended_transactions: transactionLevel.value,
        tax_id: taxId.value,
        beneficial_ownership_with_caprock: ownership.value,
        documents: [
          {
            file_id: fileAttorneyPath.value.file_id,
            file_name: fileAttorneyPath.value.file_name,
          },
        ],
        is_submitted: isFinal,
      };
    }
    try {
      const response = await fetch(apiUrl, {
        method: isOnbaording ? "POST" : "PUT",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleSelectCountryCode = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setCountryCode({
      ...countryCode,
      value: {
        id: selectedOption.value,
        name: selectedOption.label,
      },
    });
  };
  const handlesave = async (isFinal) => {
    let toastMessage = null;
    try {
      let payloadAddress = {};
      if (apIAddress != null) {
        payloadAddress = {
          address_line_1:
            apIAddress.address_line_1 == null
              ? apIAddress.google_address
              : apIAddress.address_line_1,
          address_line_2:
            apIAddress.address_line_2 == null
              ? null
              : apIAddress.address_line_2,
          city_id: apIAddress.city != null ? apIAddress.city.id : null,
          state_id: apIAddress.city != null ? apIAddress.city.state_id : null,
          country_id: redCountry,
          zip_code: apIAddress.postal_code,
          google_address: apIAddress.google_address,
        };
      } else {
        payloadAddress = {
          address_line_1:
            businessAddress.value.street == ""
              ? businessAddress.value.full
              : businessAddress.value.street,
          address_line_2: businessAddress.value.route,
          city_id: redCity,
          state_id: redState,
          country_id: redCountry,
          zip_code: businessAddress.value.zip,
          google_address: businessAddress.value.full,
        };
      }
      if (payloadAddress.city_id === null) {
        showToast("Please select a valid city before proceeding.", "error");
        return; // Stop execution if city_id is missing
      }
      const response = await submitApplicationAPI(isFinal, payloadAddress);
      if (response.status == 200) {
        if (isFinal) {
          setCurrentStep(3);
          toastMessage = {
            message: response.message,
            type: "success",
          };
          const responseStatus = await GetAPIcalls(`/v1/onboarding/status`);
          if (responseStatus.status == 200) {
            if (responseStatus.data.length > 0) {
              dispatch(setStepStatus(responseStatus.data));
            }
          }
          const responseRejected = await GetAPIcalls(
            `/v1/onboarding/rejected-fields`,
          );
          if (responseRejected.status == 200) {
            dispatch(setRejectedFields(responseRejected.data)); // <-- Save in Redux
          }
        } else {
          toastMessage = {
            message:
              "Information has been saved successfully. Please submit to proceed further.",
            type: "success",
          };
        }
      } else {
        toastMessage = { message: response.message, type: "error" };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: "error" };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later",
      );
    }
  };
  const getCountries = async (page, searchTerm) => {
    try {
      // Backend should support pagination & search
      const size = 10; // fetch 50 cities per page
      const response = await GetAPIcalls(
        `/v1/user/countries?page=${page}&size=${size}&search=${
          searchTerm || ""
        }`,
      );

      if (response.status === 200) {
        const items = response.data.countries.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        return {
          items,
          hasMore: response.data.countries.length === size, // if less than size, no more data
        };
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        return { items: [], hasMore: false };
      }
    } catch (err) {
      showToast(err.message, "error");
      return { items: [], hasMore: false };
    }
  };
  const handleOwnership = (e) => {
    const value = e.target.value === "true"; // convert string → boolean
    setOwnership({
      ...ownership,
      value: value,
    });
  };

  const getDetailsWithVerification = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/onboarding/business-information/individual/verification/preview`,
      );

      if (response.status == 200) {
        if (response.data) {
          setcitizenType(response.data.tax_resident_country);
          setpreselectedCitizenType({
            value: response.data.tax_resident_country.value.id,
            label: response.data.tax_resident_country.value.name,
          });
          if (response.data.tax_resident_country.value.id == 2) {
            setCountryCode(response.data.country);
            setpreselectedCountryCode({
              value: response.data.country.value.id,
              label: response.data.country.value.name,
            });
          }
          setApIAddress(response.data.business_address.value);
          setBusinessAddress(response.data.business_address);
          setBusinessName(response.data.business_name);
          setAbn(response.data.abn);

          if (response.data.tax_resident_country.value.id != 1) {
            setBusinessNature(response.data.business_nature);
            setpreselectedBusinessNature({
              value: response.data.business_nature.value.id,
              label: response.data.business_nature.value.name,
            });
            setBusinessRegNumber(response.data.business_registration_number);
            setActivity(response.data.business_activity);
            setpreselectedBusinessActivity({
              value: response.data.business_activity.value.id,
              label: response.data.business_activity.value.name,
            });
            setOtherActivity(response.data.other_business_activity);
            setSource(response.data.source_of_funds);
            setAccountPurpose(response.data.purpose_of_opening_account);
            setfileAttorneyPath(response.data.documents[0]);

            setTransactionLevel(
              response.data.nature_n_level_of_intended_transactions,
            );
            setTaxId(response.data.tax_id);
            setOwnership(response.data.beneficial_ownership_with_caprock);
          }
        } else {
          setcitizenType({
            verification_id: null,
            value: {
              id: 1,
              name: "Australian",
            },
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setpreselectedCitizenType({
            value: 1,
            label: "Australian",
          });
          setCountryCode({
            verification_id: null,
            value: {
              id: 14,
              name: "Australia",
            },
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setpreselectedCountryCode({});

          setApIAddress("");
          setBusinessAddress({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setBusinessName({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setAbn({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });

          setBusinessNature({
            verification_id: null,
            value: {
              id: null,
              name: "",
            },
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setpreselectedBusinessNature({});
          setBusinessRegNumber({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setActivity({
            verification_id: null,
            value: {
              id: null,
              name: "",
            },
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setpreselectedBusinessActivity({});
          setOtherActivity({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setSource({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setAccountPurpose({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setfileAttorneyPath({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });

          setTransactionLevel({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setTaxId({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setOwnership({
            verification_id: null,
            value: true,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  useEffect(() => {
    getAllCountries();
    getAllEnums();
  }, []);
  useEffect(() => {
    if (
      businessActivityData.length > 0 &&
      businessNatureData.length > 0 &&
      stepStatus.length > 0 &&
      stepStatus[1].status != "DRAFT"
    ) {
      getDetailsWithVerification();
    }
  }, [businessActivityData, businessNatureData, stepStatus]);
  useEffect(() => {
    if (
      businessActivityData.length > 0 &&
      businessNatureData.length > 0 &&
      updateFieldStatus &&
      stepStatus.length > 0 &&
      stepStatus[0].status != "DRAFT"
    ) {
      getDetailsWithVerification();
    }
  }, [businessActivityData, businessNatureData, updateFieldStatus, stepStatus]);

  return (
    <div className="flex flex-col min-h-[calc(100vh-100px)] lg:min-w-[80vw] lg:max-w-[80vw]">
      <div className="flex-grow  overflow-visible">
        {loading && (
          <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        {stepStatus.length > 0 &&
          (stepStatus[1].status == "IN_REVIEW" ||
            stepStatus[1].status == "COMPLETED") && (
            <div className="mb-2 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded-md text-sm flex items-center">
              <img
                src="/warning-circle.svg"
                alt="Info"
                className="w-4 h-4 mr-2"
              />
              <span>
                This section is{" "}
                <strong>in review by our onboarding team</strong>. You will be
                notified once the verification is complete.{" "}
              </span>
            </div>
          )}
        {stepStatus.length > 0 && stepStatus[1].status == "APPROVED" && (
          <div className="mb-2 bg-green-100 border-l-4 border-green-500 text-green-700 p-3 rounded-md text-sm flex items-center">
            <span>
              This section has been <strong>approved</strong> by our onboarding
              team.
            </span>
          </div>
        )}
        {rejectedFields?.BUSINESS_INFORMATION?.rejected_fields?.length > 0 && (
          <div className="mb-3 p-3 bg-red-50 border border-red-200 rounded-md">
            <p className="font-semibold text-red-700 mb-1">
              {rejectedFields.BUSINESS_INFORMATION.rejected_fields.length === 1
                ? "The following field requires correction:"
                : "The following fields require correction:"}{" "}
            </p>

            <div className="flex flex-wrap gap-2">
              {rejectedFields.BUSINESS_INFORMATION.rejected_fields.map(
                (field) => (
                  <span
                    key={field}
                    className="px-2 py-1 bg-red-100 text-red-700 text-xs rounded"
                  >
                    {fieldLabelMap[field] || field.replace(/_/g, " ")}
                  </span>
                ),
              )}
            </div>
          </div>
        )}
        <div className="bg-white shadow-md rounded-md p-4 mb-4">
          <div className=" border-b border-colour-custom pb-2">
            <div className="flex items-center space-x-2">
              <img
                src="/buildings.svg"
                alt="User Avatar"
                className="h-6 w-6 mb-2"
              />
              <h1 className="text-xl font-medium mb-2">Business Information</h1>
            </div>
            <li className="text-xs ml-2 font-medium text-[#FF5050]">
              If you need to adjust any information from the previous section,
              please click on the “Reset Application” button
            </li>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
              <div className="mb-2">
                <LabelWithStatus
                  id="citizenType"
                  label={fieldLabelMap.tax_resident_country}
                  required={true}
                  fieldData={citizenType}
                  handleStatusClick={handleStatusClick}
                />
                <Dropdown
                  label=""
                  options={citizenTypedata}
                  onSelect={handleSelectCitizenType}
                  preselectedValue={preselectedCitizenType}
                  parentClass={
                    citizenType.status == "rejected"
                      ? "border-[#FF5050] border-2"
                      : ""
                  }
                />
              </div>
              {citizenType.value.id == 2 && (
                <>
                  <div className="mt-2">
                    <LabelWithStatus
                      id="citizenTypeCountry"
                      label={fieldLabelMap.country_id}
                      required={true}
                      fieldData={countryCode}
                      handleStatusClick={handleStatusClick}
                    />
                    <CustomDropdownWithFetch
                      label=""
                      options={countryCodeData}
                      search={true}
                      preselectedValue={preselectedCountryCode}
                      onSelect={handleSelectCountryCode}
                      colorLabel=""
                      parentClass={
                        countryCode.status == "rejected"
                          ? "border-[#FF5050] border-2"
                          : ""
                      }
                      fetchOptions={getCountries} // <-- pass fetch function, not options
                    />
                  </div>
                </>
              )}

              <div className="mt-2">
                <LabelWithStatus
                  id="businessNature"
                  label={fieldLabelMap.business_nature}
                  required={true}
                  fieldData={businessNature}
                  handleStatusClick={handleStatusClick}
                />
                <Dropdown
                  label=""
                  options={businessNatureData}
                  preselectedValue={preselectedBusinessNature}
                  onSelect={handleSelectBusinessNature}
                  disabled={businessNature.status == "approved" ? true : false}
                  parentClass={
                    businessNature.status == "rejected"
                      ? "border-[#FF5050] border-2"
                      : ""
                  }
                />
              </div>
              {(citizenType.value.id == 2 || citizenType.value.id == 3) && (
                <>
                  <div className="mt-4">
                    <LabelWithStatus
                      id="businessRegistrationNumber"
                      label={fieldLabelMap.business_registration_number}
                      required={true}
                      fieldData={businessRegNumber}
                      handleStatusClick={handleStatusClick}
                    />
                    <input
                      id="businessRegNumber"
                      name="businessRegNumber"
                      type="text"
                      value={businessRegNumber.value}
                      placeholder="Enter Number"
                      disabled={
                        businessRegNumber.status == "approved" ? true : false
                      }
                      className={`${
                        businessRegNumber.status == "rejected"
                          ? "border-[#FF5050] border-2"
                          : ""
                      } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                      onChange={(e) =>
                        setBusinessRegNumber({
                          ...businessRegNumber,
                          value: e.target.value,
                        })
                      }
                    />
                  </div>
                </>
              )}
              {citizenType.value.id == 3 && (
                <div className="mt-4">
                  <LabelWithStatus
                    id="taxID"
                    label={fieldLabelMap.tax_id}
                    required={true}
                    fieldData={taxId}
                    handleStatusClick={handleStatusClick}
                  />
                  <input
                    id="taxID"
                    name="taxID"
                    type="text"
                    value={taxId.value}
                    placeholder="Enter Number"
                    disabled={taxId.status == "approved" ? true : false}
                    className={`${
                      taxId.status == "rejected"
                        ? "border-[#FF5050] border-2"
                        : ""
                    } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                    onChange={(e) =>
                      setTaxId({
                        ...taxId,
                        value: e.target.value,
                      })
                    }
                  />
                </div>
              )}
              {citizenType.value.id == 1 && (
                <div className="mt-4">
                  <LabelWithStatus
                    id="abn"
                    label={fieldLabelMap.abn}
                    required={true}
                    fieldData={abn}
                    handleStatusClick={handleStatusClick}
                  />

                  <input
                    id="abn"
                    name="abn"
                    type="text"
                    value={abn.value}
                    placeholder="Enter ABN"
                    disabled={abn.status == "approved" ? true : false}
                    className={`${
                      abn.status == "rejected"
                        ? "border-[#FF5050] border-2"
                        : ""
                    } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                    onChange={(e) =>
                      setAbn({
                        ...abn,
                        value: e.target.value,
                      })
                    }
                  />
                </div>
              )}
            </div>
            <div className="flex lg:pt-4 pt-0 flex-col px-4 md:pl-0 pr-4 sm:border-r-0 md:border-r border-gray-300">
              <div className="">
                <LabelWithStatus
                  id="businessName"
                  label={fieldLabelMap.business_name}
                  required={true}
                  fieldData={businessName}
                  handleStatusClick={handleStatusClick}
                />
                <input
                  id="businessName"
                  name="businessName"
                  type="text"
                  value={businessName.value}
                  placeholder="Business Name"
                  disabled={businessName.status == "approved" ? true : false}
                  className={`${
                    businessName.status == "rejected"
                      ? "border-[#FF5050] border-2"
                      : ""
                  } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                  onChange={(e) =>
                    setBusinessName({
                      ...businessName,
                      value: e.target.value,
                    })
                  }
                />
              </div>

              <div className="mt-4">
                <LabelWithStatus
                  id="activityType"
                  label={fieldLabelMap.business_activity}
                  required={true}
                  fieldData={activity}
                  handleStatusClick={handleStatusClick}
                />
                <Dropdown
                  label=""
                  preselectedValue={preselectedBusinessActivity}
                  options={businessActivityData}
                  onSelect={handleSelectActivity}
                  disabled={activity.status == "approved" ? true : false}
                  parentClass={
                    activity.status == "rejected"
                      ? "border-[#FF5050] border-2"
                      : ""
                  }
                />
                {activity.value.id == 6 && (
                  <div className="mt-4">
                    <LabelWithStatus
                      id="others"
                      label={fieldLabelMap.other_business_activity}
                      required={true}
                      fieldData={otherActivity}
                      handleStatusClick={handleStatusClick}
                    />
                    <input
                      id="others"
                      name="others"
                      type="text"
                      value={otherActivity.value}
                      disabled={
                        otherActivity.status == "approved" ? true : false
                      }
                      placeholder="Other activity"
                      className={`${
                        otherActivity.status == "rejected"
                          ? "border-[#FF5050] border-2"
                          : ""
                      } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                      onChange={(e) =>
                        setOtherActivity({
                          ...otherActivity,
                          value: e.target.value,
                        })
                      }
                    />
                  </div>
                )}
                <div className="mt-4">
                  <LabelWithStatus
                    id="source"
                    label={fieldLabelMap.source_of_funds}
                    required={true}
                    fieldData={source}
                    handleStatusClick={handleStatusClick}
                  />
                  <input
                    id="source"
                    name="source"
                    type="text"
                    value={source.value}
                    placeholder="Enter Source"
                    disabled={source.status == "approved" ? true : false}
                    className={`${
                      source.status == "rejected"
                        ? "border-[#FF5050] border-2"
                        : ""
                    } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                    onChange={(e) =>
                      setSource({
                        ...source,
                        value: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="mt-4">
                  <LabelWithStatus
                    id="accountPurpose"
                    label={fieldLabelMap.purpose_of_opening_account}
                    required={true}
                    fieldData={accountPurpose}
                    handleStatusClick={handleStatusClick}
                  />
                  <input
                    id="accountPurpose"
                    name="accountPurpose"
                    type="text"
                    value={accountPurpose.value}
                    placeholder="Enter purpose"
                    className={`${
                      accountPurpose.status == "rejected"
                        ? "border-[#FF5050] border-2"
                        : ""
                    } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                    onChange={(e) =>
                      setAccountPurpose({
                        ...accountPurpose,
                        value: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="mt-4">
                  <div className="flex items-center justify-between">
                    <LabelWithStatus
                      id="fileUpload"
                      label={fieldLabelMap.documents}
                      required={false}
                      fieldData={fileAttorneyPath}
                      handleStatusClick={handleStatusClick}
                    />
                  </div>
                  {/* Drag & Drop Upload Area */}
                  <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                    <input
                      type="file"
                      id="fileUpload"
                      accept=".pdf,.png,.jpeg"
                      onChange={handleFileChangeAttorney}
                      disabled={
                        fileAttorneyPath.status == "approved" ? true : false
                      }
                      className="hidden"
                    />
                    <img
                      src="/folder-add.svg"
                      alt="Success Icon"
                      className="h-4 w-4"
                    />{" "}
                    <p
                      disabled={
                        fileAttorneyPath.status == "approved" ? true : false
                      }
                      className="mt-2 text-gray-500 text-sm"
                    >
                      Drag & Drop <br />
                      or <span className="underline">Click to Upload</span>
                    </p>
                  </label>
                  <div className="mt-1">
                    <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                      PNG
                    </span>
                    <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                      JPEG
                    </span>
                    <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                      PDF
                    </span>
                    <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                      &#60; 10 MB
                    </span>
                  </div>

                  {((fileAttorney && fileAvailable) ||
                    fileAttorneyPath.value) && (
                    <div
                      className={`${
                        fileAttorneyPath.status == "rejected"
                          ? "border-[#FF5050] border-2"
                          : "border"
                      }  mt-4 bg-white  shadow-md rounded-lg flex items-center justify-between px-3 py-2`}
                    >
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          handleFileClick(e, fileAttorneyPath.value);
                        }}
                        className="flex-col flex"
                      >
                        <span className="text-black break-all underline cursor-pointer">
                          {fileAttorneyPath.value.file_name}
                        </span>
                        <span className="text-[#46DA55] text-xs">
                          Upload Completed
                        </span>
                      </div>
                      {fileAttorneyPath.status != "approved" && (
                        <button
                          onClick={handleDeleteFile}
                          className="text-red-500 flex-shrink-0 font-semibold"
                        >
                          <img
                            src="/trash.svg"
                            alt="Delete Icon"
                            className="h-4 w-4 flex-shrink-0"
                          />
                        </button>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {isModalOpen && currentDocument && (
              <DocumentPreview
                fileUrl={
                  currentDocument.presigned_url
                    ? currentDocument.presigned_url
                    : currentDocument.url
                }
                fileName={currentDocument.file_name}
                onClose={() => setIsModalOpen(false)}
              />
            )}
            <div className="flex lg:pt-4 pt-0 flex-col px-4">
              <div className="">
                <div className="">
                  <LabelWithStatus
                    id="address"
                    label={fieldLabelMap.address_id}
                    required={true}
                    fieldData={businessAddress}
                    handleStatusClick={handleStatusClick}
                  />
                  <AddressAutocomplete
                    value={
                      businessAddress?.value?.full ||
                      apIAddress?.google_address ||
                      ""
                    }
                    onSelect={(addr) => {
                      setApIAddress(null);
                      setBusinessAddress({
                        ...businessAddress,
                        value: addr,
                      });
                    }}
                    disabled={
                      businessAddress.status == "approved" ? true : false
                    }
                    className={
                      businessAddress.status == "rejected"
                        ? "border-[#FF5050] border-2 w-full"
                        : "w-full"
                    }
                  />
                </div>
              </div>
              <div className="mt-6">
                <LabelWithStatus
                  id="transactionLevel"
                  label={fieldLabelMap.nature_n_level_of_intended_transactions}
                  required={true}
                  fieldData={transactionLevel}
                  handleStatusClick={handleStatusClick}
                />
                <input
                  id="transactionLevel"
                  name="transactionLevel"
                  type="text"
                  value={transactionLevel.value}
                  placeholder="Enter transaction behaviour"
                  disabled={
                    transactionLevel.status == "approved" ? true : false
                  }
                  className={`${
                    transactionLevel.status == "rejected"
                      ? "border-[#FF5050] border-2"
                      : ""
                  } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                  onChange={(e) =>
                    setTransactionLevel({
                      ...transactionLevel,
                      value: e.target.value,
                    })
                  }
                />
              </div>
              <div className="mt-4">
                <LabelWithStatus
                  id="ownership"
                  label={fieldLabelMap.beneficial_ownership_with_caprock}
                  required={true}
                  fieldData={ownership}
                  handleStatusClick={handleStatusClick}
                />
                <div className="flex items-center gap-4">
                  <label className="flex items-center text-sm text-black">
                    <input
                      type="radio"
                      name="ownership"
                      value={true}
                      checked={ownership.value === true}
                      disabled={ownership.status == "approved" ? true : false}
                      onChange={handleOwnership}
                      className={`${
                        ownership.status == "rejected"
                          ? "border-[#FF5050] border-2"
                          : "border-gray-300"
                      } confirm-check w-4 h-4 text-[#005A9C]  focus:ring-[#005A9C]`}
                    />
                    <span className="ml-2">Yes</span>
                  </label>

                  <label className="flex items-center text-sm text-black">
                    <input
                      type="radio"
                      name="ownership"
                      value={false}
                      disabled={ownership.status == "approved" ? true : false}
                      checked={ownership.value === false}
                      onChange={handleOwnership}
                      className={`${
                        ownership.status == "rejected"
                          ? "border-[#FF5050] border-2"
                          : "border-gray-300"
                      } confirm-check w-4 h-4 text-[#005A9C]  focus:ring-[#005A9C]`}
                    />
                    <span className="ml-2">No</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showPopup && currentField && (
        <ReviewPopup
          isOpen={showPopup}
          currentField={currentField}
          currentFieldName={currentFieldName}
          currentFieldValue={currentFieldValue}
          currentFieldType={currentFieldType}
          onClose={() => setShowPopup(false)}
        />
      )}
      <footer className="mt-4 flex flex-col flex-shrink-0 md:flex-row p-4 bg-[#005A9C]">
        {stepStatus.length > 0 &&
          stepStatus[1].status != "COMPLETED" &&
          stepStatus[1].status != "APPROVED" &&
          stepStatus[1].status != "IN_REVIEW" && (
            <>
              {" "}
              <div className="flex flex-col md:flex-row items-center justify-start w-full space-y-2 md:space-y-0">
                <ConfirmResetButton
                  onConfirm={handleReset}
                  isReset={true}
                  isBack={true}
                  onBack={handleBack}
                />
              </div>
              <div className="bottom-actions flex flex-col md:flex-row mt-2 md:mt-0 items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4">
                <div className="w-full md:w-auto flex justify-center md:justify-end">
                  <button
                    onClick={() => {
                      handleContinue(false);
                    }}
                    className="flex w-full md:w-auto items-center justify-center space-x-2 text-white border-white border-2 font-medium py-2 px-4 rounded-full text-sm"
                  >
                    <span>Save as Draft</span>
                  </button>
                </div>
                <ConfirmContinueButton
                  onContinue={() => handleContinue(true)}
                  buttonText="Continue"
                  confirmTitle="Save Section"
                  confirmMessage="Are you sure, you want to continue. This action will ensure, the saved information is un-editable. Therefore please make sure you have provided the correct details."
                />
              </div>
            </>
          )}
        {stepStatus.length > 0 &&
          (stepStatus[1].status == "COMPLETED" ||
            stepStatus[1].status == "APPROVED" ||
            stepStatus[1].status == "IN_REVIEW") && (
            <>
              <div className="flex flex-col md:flex-row items-center justify-start w-full space-y-2 md:space-y-0">
                <ConfirmResetButton
                  onConfirm={handleReset}
                  isReset={false}
                  isBack={true}
                  onBack={handleBack}
                />
              </div>
              <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
                {/* Save as Draft */}
                <button
                  onClick={() => {
                    setCurrentStep(3);
                  }}
                  className="flex w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
                >
                  <span>Next</span>
                </button>
              </div>
            </>
          )}
      </footer>
    </div>
  );
};

export default BusinessInfo;
